import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _map from "lodash/map";
import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Box } from '@nerdwallet/currency';
import NerdWalletLogo from '@nerdwallet/react-nerdwallet-logo';
import FlyOutHeaderSection from './fly-out-header-section';
import './fly-out-header.less';

var FlyOutHeader = function FlyOutHeader(_ref) {
  var pageSection = _ref.pageSection,
      sections = _ref.sections;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isNavOpen = _useState2[0],
      setIsNavOpen = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      headerShadow = _useState4[0],
      setHeaderShadow = _useState4[1];

  var handleScrollEvent = useCallback(function () {
    if (window.pageYOffset > 2) {
      setHeaderShadow(true);
    } else setHeaderShadow(false);
  }, []);
  useEffect(function () {
    handleScrollEvent();
    window.addEventListener('scroll', handleScrollEvent, true);
    return function () {
      window.removeEventListener('scroll', handleScrollEvent, true);
    };
  }, [handleScrollEvent]);
  var navToggle = isNavOpen ? 'fly-out-header__mask--open' : 'fly-out-header__mask--closed';
  var brandNavToggle = isNavOpen ? 'fly-out-header__nav--open' : 'fly-out-header__nav--closed';

  var HeaderLinks = _map(sections, function (section) {
    return /*#__PURE__*/React.createElement(FlyOutHeaderSection, _extends({}, section, {
      pageSection: pageSection,
      isNavOpen: isNavOpen,
      setIsNavOpen: setIsNavOpen
    }));
  });

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classNames('fly-out-header__nav', brandNavToggle)
  }, /*#__PURE__*/React.createElement("button", {
    className: "fly-out-header__close",
    type: "button",
    "aria-label": "Close Navigation",
    onClick: function onClick() {
      return setIsNavOpen(!isNavOpen);
    }
  }, "\xD7"), /*#__PURE__*/React.createElement("div", {
    className: "fly-out-header__links"
  }, HeaderLinks)), /*#__PURE__*/React.createElement(Box, {
    className: navToggle,
    isNavOpen: isNavOpen,
    onClick: function onClick() {
      return setIsNavOpen(!isNavOpen);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames('fly-out-header', {
      'shadow--on': headerShadow
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "fly-out-header__logo"
  }, /*#__PURE__*/React.createElement(NerdWalletLogo, null)), /*#__PURE__*/React.createElement("button", {
    className: "fly-out-header__open",
    "aria-label": "Open Navigation",
    type: "button",
    onClick: function onClick() {
      return setIsNavOpen(!isNavOpen);
    }
  }, "\u2630")));
};

FlyOutHeader.propTypes = {
  sections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    url: PropTypes.string,
    subsections: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      url: PropTypes.string
    }))
  })),
  pageSection: PropTypes.string
};
FlyOutHeader.defaultProps = {
  pageSection: '',
  sections: []
};
FlyOutHeader.displayName = 'FlyOutHeader';
export default FlyOutHeader;